// eslint-disable-next-line import/prefer-default-export
export const RETRIEVE_DISTRICTS = 'commercial/districts/retrieve';